import { TabBarSkeleton } from "@/components/TabBarSkeleton";
import { ReferralLinksSkeleton } from "./referral-links/ReferralLinksSkeleton";

/**
 * Full-page skeleton for the App Detail route's pendingComponent.
 * Shows tab bar and the default Referral Links tab skeleton.
 */
export function AppDetailPageSkeleton() {
	return (
		<div>
			<TabBarSkeleton tabWidths={[100, 70]} />
			<div className="mt-4">
				<ReferralLinksSkeleton />
			</div>
		</div>
	);
}
